import { render, staticRenderFns } from "./carouselChart.vue?vue&type=template&id=5c052c72&scoped=true&"
import script from "./carouselChart.vue?vue&type=script&lang=js&"
export * from "./carouselChart.vue?vue&type=script&lang=js&"
import style0 from "./carouselChart.vue?vue&type=style&index=0&id=5c052c72&prod&lang=scss&"
import style1 from "./carouselChart.vue?vue&type=style&index=1&id=5c052c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c052c72",
  null
  
)

export default component.exports